import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ConfigService} from './config.service';
import {SecurityService} from './security.service';
import {NumbersPricingModel} from '../models/numbersPricing.model';
import {PPhostedPricing} from '../models/PPhostedPricing.model';
import {NiceNumbersModel} from '../models/niceNumbers.model';
import {IspPricingModel} from '../models/IspPricing.model';
import {InternetOptionModel} from '../models/InternetOption.model';
import {DataStorageService} from './data-storage.service';
import {ThreeCXPricing} from '../models/ThreeCXPricing';
import {MicrosoftTeamsPricing} from '../models/MicrosoftTeamsPricing';
import {PeoplefoneBundlePricing} from '../models/PeoplefoneBundlePricing';
import {MitelHostedModel} from '../models/MitelHosted.model';
import {SipTrunkPricing} from '../models/SipTrunkPricing';
import { DatasimPrincing } from '../models/DatasimPricing';
import { SBCplusPrincing } from '../models/SBCplusPricing';
import { MobilePricing } from '../models/MobilePricing';
import {MobileOptionModel} from '../models/MobileOption.model';
@Injectable()
export class PricingService {

  constructor(private http: HttpClient,
              private configService: ConfigService,
              private securityService: SecurityService,
              private dataStorageService: DataStorageService) {
  }

  getISPpricingPricelist(type: string): Promise<IspPricingModel[]> {
    return new Promise<IspPricingModel[]>((resolve, reject) => {
      const url = this.configService.host
        + '/api/pricelist/internet-technology'
        + '?type=' + type;
      this.http.get<IspPricingModel[]>(url)
        .toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.getISPpricingPricelist(type).then((data) => resolve(data));
            });
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  getOption(type: string, key: string): Promise<InternetOptionModel[]> {

    return new Promise<InternetOptionModel[]>((resolve, reject) => {
      const url = this.configService.host
        + '/api/pricelist/internet-option'
        + '?type=' + type
        + '&key=' + key;
      this.http.get<InternetOptionModel[]>(url).toPromise().then(response => {
        const tmp = [];
        response.map(e => {
          e.uniqueCost = e['costUnique'];
          e.monthlyCost = e['costMonthly'];
          tmp.push(e);
        });
        resolve(tmp);
      })
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getOption(type, key).then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }

        });
    });
  }

  /**-PORTED-NUMBERS--------------------------------------------------------------------------------------------------*/
  getPortedNumbersPricelist(): Promise<NumbersPricingModel[]> {
    return new Promise<any>((resolve, reject) => {
      const url = this.configService.host
        + '/api/pricelist/ported-numbers';
      this.http.get<NumbersPricingModel[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.getPortedNumbersPricelist().then((data) => resolve(data));
            });
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  /**-NEW-NUMBERS-----------------------------------------------------------------------------------------------------*/
  getNewNumbersPricelist(): Promise<any> {
    const url = this.configService.host
      + '/api/pricelist/new-numbers';
    return new Promise<any>((resolve, reject) => {
      this.http.get<NumbersPricingModel[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.getNewNumbersPricelist().then((data) => resolve(data));
            });
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  getNewNumbersNiceOptions(): Promise<NiceNumbersModel[]> {
    const url = this.configService.host
      + '/api/pricelist/new-numbers-category';
    return new Promise<NiceNumbersModel[]>((resolve, reject) => {
      this.http.get<NiceNumbersModel[]>(url)
        .toPromise()
        .then((response) => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.getNewNumbersNiceOptions().then((data) => resolve(data));
            });
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });

  }


  /**-PP-HOSTED-------------------------------------------------------------------------------------------------------*/
  getPPHostedUsersPricelist(): Promise<PPhostedPricing[]> {
    const url = this.configService.host
      + '/api/pricelist/pf-hosted-users';
    return new Promise<PPhostedPricing[]>((resolve, reject) => {
      this.http.get<PPhostedPricing[]>(url)
        .toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHostedUsersPricelist().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  getPPHostedNodesPricelist(): Promise<PPhostedPricing[]> {
    const url = this.configService.host
      + '/api/pricelist/pf-hosted-nodes';
    return new Promise<PPhostedPricing[]>((resolve, reject) => {
      this.http.get<PPhostedPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHostedNodesPricelist().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }
  getPPHostedSoftphonePricelist(): Promise<PPhostedPricing[]> {
    const url = this.configService.host
      + '/api/pricelist/pf-hosted-softphone';
    return new Promise<PPhostedPricing[]>((resolve, reject) => {
      this.http.get<PPhostedPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHostedSoftphonePricelist().then((data) => resolve(data)));
          } else {
             //console.log(error);
            reject(error);
          }
        });
    });
  }

  getPPHostedConnectorStanPricelist(): Promise<PPhostedPricing[]> {
    const url = this.configService.host
      + '/api/pricelist/pf-hosted-connector-standard';
    return new Promise<PPhostedPricing[]>((resolve, reject) => {
      this.http.get<PPhostedPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHostedConnectorStanPricelist().then((data) => resolve(data)));
          } else {
           // console.log(error);
            reject(error);
          }
        });
    });
  }

  getPPHostedConnectorApiPricelist(): Promise<PPhostedPricing[]> {
    const url = this.configService.host
      + '/api/pricelist/pf-hosted-connector-api';
    return new Promise<PPhostedPricing[]>((resolve, reject) => {
      this.http.get<PPhostedPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHostedConnectorApiPricelist().then((data) => resolve(data)));
          } else {
           // console.log(error);
            reject(error);
          }
        });
    });
  }






  /**-FLAT-RATE-------------------------------------------------------------------------------------------------------*/
  getFlatRate(type: 'HOSTED' | 'SIP'): Promise<FlatRatePricingModel[]> {
    let url = this.configService.host;
    url += type === 'HOSTED' ? '/api/pricelist/biz-flrat-hosted' : '/api/pricelist/biz-flrat-siptrunk';

    return new Promise<FlatRatePricingModel[]>( ((resolve, reject) => {
      this.http.get<FlatRatePricingModel[]>(url).subscribe(response => resolve(response), (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken().then( () => this.getFlatRate( type) );
        } else {
          // console.log(error);
          reject(error);
        }
      });
    }));
  }

  /**-3CX-------------------------------------------------------------------------------------------------------------*/
  get3CXPriceList() {
    const url = this.configService.host + '/api/pricelist/3cx';

    return new Promise<ThreeCXPricing[]>((resolve, reject) => {
      this.http.get<ThreeCXPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.get3CXPriceList().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  /**-MS Teams-------------------------------------------------------------------------------------------------------------*/
  getMsTeamsPriceList(type='msTeams') {
    const url = this.configService.host + '/api/pricelist/' + type;

    return new Promise<MicrosoftTeamsPricing[]>((resolve, reject) => {
      this.http.get<MicrosoftTeamsPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getMsTeamsPriceList(type).then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  /**-Pf Bundle-------------------------------------------------------------------------------------------------------------*/
  getPfBundlePriceList() {
    const url = this.configService.host + '/api/pricelist/pfBundle';

    return new Promise<PeoplefoneBundlePricing[]>((resolve, reject) => {
      this.http.get<PeoplefoneBundlePricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPfBundlePriceList().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  /**-SipTrunk-------------------------------------------------------------------------------------------------------------*/
  getSipTrunkPriceList() {
    const url = this.configService.host + '/api/pricelist/sipTrunk';

    return new Promise<SipTrunkPricing[]>((resolve, reject) => {
      this.http.get<SipTrunkPricing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getSipTrunkPriceList().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }
  // /**-FLAT-RATE-HOSTED------------------------------------------------------------------------------------------------*/
  // getFlatRateHosted(type: string): Promise<FlatRateModel> {
  //   return new Promise<FlatRateModel>((resolve, reject) => {
  //     const returned = new FlatRateModel();
  //     const url = this.configService.host + '/api/pricelist/biz-flrat-hosted';
  //     this.http.get<any>(url)
  //       .toPromise()
  //       .then(response => {
  //         returned.networkType = type;
  //         returned.countMin = response[type].countMin;
  //         returned.countMax = response[type].countMax;
  //         returned.unitFixnetMinutes = response[type].unitFixnetMinutes;
  //         returned.unitMobilenetMinutes = response[type].unitMobilenetMinutes;
  //         returned.unitMonthlyCost = response[type].unitMonthlyCost;
  //         resolve(returned);
  //       })
  //       .catch((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //           this.securityService.refreshToken()
  //             .then(() => this.getFlatRateHosted(type).then((data) => resolve(data)));
  //         } else {
  //           console.log(error);
  //           reject(error);
  //         }
  //       });
  //   });
  // }
  //
  // /**-FLAT-RATE-SIPTRUNK----------------------------------------------------------------------------------------------*/
  // getFlatRateSiptrunk(type: string): Promise<FlatRateModel> {
  //   return new Promise<FlatRateModel>((resolve, reject) => {
  //     const returned = new FlatRateModel();
  //     const url = this.configService.host + '/api/pricelist/biz-flrat-siptrunk';
  //     this.http.get<any>(url)
  //       .toPromise()
  //       .then(response => {
  //         returned.networkType = type;
  //         returned.countMin = response[type].countMin;
  //         returned.countMax = response[type].countMax;
  //         returned.unitFixnetMinutes = response[type].unitFixnetMinutes;
  //         returned.unitMobilenetMinutes = response[type].unitMobilenetMinutes;
  //         returned.unitMonthlyCost = response[type].unitMonthlyCost;
  //         resolve(returned);
  //       })
  //       .catch((error: HttpErrorResponse) => {
  //         if (error.status === 401) {
  //           this.securityService.refreshToken()
  //             .then(() => this.getFlatRateSiptrunk(type).then((data) => resolve(data)));
  //         } else {
  //           console.log(error);
  //           reject(error);
  //         }
  //       });
  //   });
  // }


  getDatasimPriceList() {
    const url = this.configService.host + '/api/pricelist/datasim';

    return new Promise<DatasimPrincing[]>((resolve, reject) => {
      this.http.get<DatasimPrincing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getDatasimPriceList().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }

  getSBCplusPriceList() {
    const url = this.configService.host + '/api/pricelist/sbcplus';
    return new Promise<SBCplusPrincing[]>((resolve, reject) => {
      this.http.get<SBCplusPrincing[]>(url).toPromise()
        .then(response => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getSBCplusPriceList().then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });

  }


    //Mobile PriceList
    getMobilePriceList() {
      const url = this.configService.host + '/api/pricelist/mobile';

      return new Promise<MobilePricing[]>((resolve, reject) => {
        this.http.get<MobilePricing[]>(url).toPromise()
          .then(response => resolve(response))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.getMobilePriceList().then((data) => resolve(data)));
            } else {
              // console.log(error);
              reject(error);
            }
          });
      });
    }

  getMobileOption(key: string): Promise<MobileOptionModel[]> {

    return new Promise<MobileOptionModel[]>((resolve, reject) => {
      const url = this.configService.host
        + '/api/pricelist/mobile-option'
        + '?key=' + key;
      this.http.get<MobileOptionModel[]>(url).toPromise().then(response => {
        const tmp = [];
        response.map(e => {
          e.uniqueCost = e['costUnique'];
          e.monthlyCost = e['costMonthly'];
          tmp.push(e);
        });
        resolve(tmp);
      })
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getMobileOption( key).then((data) => resolve(data)));
          } else {
            // console.log(error);
            reject(error);
          }

        });
    });
  }



  getMitelHostedPrice(key: string) {

    const url = this.configService.host
      + '/api/pricelist/mitel-hosted'
      + '?type=' + key;
    return new Promise<MitelHostedModel[]>((resolve, reject) => {
      this.http.get<MitelHostedModel[]>(url)
        .toPromise()
        .then((response) => resolve(response))
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.getMitelHostedPrice(key).then((data) => resolve(data));
            });
          } else {
            // console.log(error);
            reject(error);
          }
        });
    });
  }
  initializePricing(): Promise<any> {
    const promises = [];

    promises.push(this.getISPpricingPricelist('IPWORLDCOM'));
    promises.push(this.getOption('IPWORLDCOM', 'IpAddress'));
    promises.push(this.getOption('IPWORLDCOM', 'SlaLevel'));
    promises.push(this.getOption('IPWORLDCOM', 'Router'));
    promises.push(this.getISPpricingPricelist('CYBERLINK'));
    promises.push(this.getOption('CYBERLINK', 'IpAddress'));
    promises.push(this.getOption('CYBERLINK', 'SlaLevel'));
    promises.push(this.getOption('CYBERLINK', 'Router'));
    promises.push(this.getOption('CYBERLINK', 'SupportTime'));
    promises.push(this.getOption('CYBERLINK', 'endtoend'));
    promises.push(this.getOption('CYBERLINK', 'mobilefallback'));
    promises.push(this.getFlatRate('HOSTED'));
    promises.push(this.getFlatRate('SIP'));
    promises.push(this.get3CXPriceList());
    promises.push(this.getMsTeamsPriceList());
    promises.push(this.getPfBundlePriceList());
    promises.push(this.getMitelHostedPrice('PeoplefoneMitelHosted'));
    promises.push(this.getMitelHostedPrice('PeoplefoneMitelCloudLink'));
    promises.push(this.getMitelHostedPrice('PeoplefoneMitelMBGTeleworker'));
    promises.push(this.getMitelHostedPrice('PeoplefoneMitelOIPCTI'));
    promises.push(this.getMitelHostedPrice('PeoplefoneMitelVPNLink'));

    return new Promise<any>(resolve => {
      Promise.all(promises).then(results => {
        this.dataStorageService.ispPricingIPWORLDCOM = results[0];
        this.dataStorageService.addressIPWORLDCOM = results[1];
        this.dataStorageService.slaIPWORLDCOM = results[2];
        this.dataStorageService.typeOfRouterIPWORLDCOM = results[3];
        this.dataStorageService.ispPricingCYBERLINK = results[4];
        this.dataStorageService.addressCYBERLINK = results[5];
        this.dataStorageService.slaCYBERLINK = results[6];
        this.dataStorageService.typeOfRouterCYBERLINK = results[7];
        this.dataStorageService.supportTimeCYBERLINK = results[8];
        this.dataStorageService.endtoend = results[9];
        this.dataStorageService.mobileFallback = results[10];
        this.dataStorageService.flatRateHostedPricing = results[11];
        this.dataStorageService.flatRateSipTrunkPricing = results[12];
        this.dataStorageService.threeCXPricing = results[13];
        this.dataStorageService.teamsPricing = results[14];
        this.dataStorageService.bundlePricing = results[15];

        this.dataStorageService.mistelHosted_hosted = results[16];
        this.dataStorageService.mistelHosted_cloundLink = results[17];
        this.dataStorageService.mistelHosted_teleworked = results[18];
        this.dataStorageService.mistelHosted_OipCti = results[19];
        this.dataStorageService.mistelHosted_VpnLink = results[20];

        resolve();
      });
    });
  }

}





// WEBPACK FOOTER //
// ./src/app/pricing.service.ts